import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  margin-left: 0.5rem;
`;

export const InputWrapper = styled.div`
  margin-top: 0.5rem;
`;
